import { type ReactNode, useMemo } from 'react';
import { type ShareItemProperties, message } from 'ui';
import { type Network, openShareNetworkPopup } from 'common/utils';
import { copyToClipboard } from 'features/copy-to-clipboard';

export type ShareAction = {
  icon: ReactNode;
  key: string;
  label: string;
  onClick?: () => void;
  socialNetwork?: Network;
  type: 'copy' | 'qr-code' | 'social';
};

export const useNetworkShareItems = ({
  actions,
  emailOnlyText,
  sharedContent,
  subject,
  text,
}: {
  actions: readonly ShareAction[];
  emailOnlyText?: boolean;
  sharedContent: string;
  subject?: string;
  text?: string;
}) =>
  useMemo(
    () =>
      actions.map(
        (action): ShareItemProperties => ({
          children: action.label,
          icon: action.icon,
          key: action.key,
          async onClick() {
            if (action.type === 'copy') {
              try {
                // eslint-disable-next-line @typescript-eslint/require-await -- Async is required by iOS interface, do not work without it
                await copyToClipboard(async () => sharedContent);
                message.success('Link copied to clipboard');
              } catch {
                message.error('Sorry, something went wrong.');
              }
            }

            if (action.type === 'social' && action.socialNetwork) {
              openShareNetworkPopup({ emailOnlyText, network: action.socialNetwork, sharedContent, subject, text });
            }

            action.onClick?.();
          },
        }),
      ),
    [actions, emailOnlyText, sharedContent, subject, text],
  );
